import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Prismic from 'prismic-javascript';
import { Link } from 'react-router-dom';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  @media (max-width: 789px) {
    display: none;
  }
  &:hover {
    .submenu {
      display: flex;
    }
    .product {
      color: #fff;
      &:after {
        transform: rotate(180deg);
        border-top: 4px solid #fff;
      }
    }
  }
  .product {
    transition: all 0.3s;
    color: #D2AE82;
    font: italic bold 22px 'Times New Roman';
    position: relative;
    padding-right: 26px;
    &:after {
      transition: all 0.3s;
      position: absolute;
      content: ' ';
      right: 12px;
      top: 12px;
      width: 0; 
      height: 0; 
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid #D2AE82;
    }
  }
  .submenu {
    position: absolute;
    background: #4B4B4B;
    left: 0;
    right: 0;
    top: 76px;
    display: flex;
    padding: 36px 20px;
    display: none;
    z-index: 600;
    .wrapper {
      width: 100%;
    }
    .column {
      width: 40%;
      &:first-child {
        width: 60%;
        margin-right: 25px;
        padding-right: 25px;
        border-right: 1px solid #242423;
        .line {
          a {
            @media (min-width: 1200px) {
              width: calc(25% - 7px);
              &:first-child {
                width: calc(50% - 7px);
              }
            }
            @media (max-width: 1200px) {
              width: calc(33% - 7px);
            }
          }
        }
      }
      &:last-child {
        .line {
          a {
            width: calc(50% - 7px);
          }
        }
      }
      strong {
        display: block;
        text-align: center;
        font: italic 36px 'Times new roman';
        color: #fff;
        margin-bottom: 30px;
      }
      .line {
        display: flex;
        justify-content: space-between;
        padding: 0 0 16px;
        a {
          border-radius: 3px;
          overflow: hidden;
          display: block;
          .img {
            height: 150px;
            background: #fff;
            width: 100%;
            display: flex;
            span {
              height: 100%;
              width: 100%;
              background-position: center;
              background-size: cover;
            }
          }
          .text {
            background: #D8D8D8;
            padding: 0 30px;
            height: 40px;
            display: flex;
            align-items: center;
            color: #40403F;
            font: 600 14px Montserrat;
            transition: all 0.3s;
          }
          &:hover {
            .text {
              background: #D2AE82;
            }
          }
        }
      }
    }
  }
`

class Submenu extends Component {
  state = {
    status: false,
    mdf: [],
    compensados: [],
    language: '',
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (language !== this.state.language) {
      this.setState({language: language, mdf: [], compensados: []})
      this.getContent();
    }
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({language: language});
    this.getContent();
  }

  getContent() {
    const { language } = this.context;
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);
    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'tipo_de_produtos'),
        {lang: language}
      )
      if (response) {
        const mdf = [];
        const compensados = [];
        response.results.map((item) => {
          switch (item.data.tipo) {
            case 'MDF':
              mdf.push(item);
              break;
            case 'Compensados':
              compensados.push(item);
              break;
            default:
          }
          return true;
        })
        const mdfOptions = []
        mdf.map((item) => {
          switch (item.uid) {
            case 'decorativos':
              mdfOptions[0] = item;
              break;
            case 'cores-basicas':
              mdfOptions[1] = item;
              break;
            case 'mdf-cru':
              mdfOptions[2] = item;
              break;
            default:
          }
          return true;
        })
        const compensadosOptions = []
        compensados.map((item) => {
          switch (item.uid) {
            case 'estruturais':
              compensadosOptions[0] = item;
              break;
            case 'nao-estruturais':
              compensadosOptions[1] = item;
              break;
            default:
          }
          return true;
        })
        this.setState({mdf: mdfOptions, compensados: compensadosOptions});
      }
    }
    fetchData();
  }

  render () {
    const { language } = this.context;
    let produtos = ''
    let compensados = ''
    switch (language) {
      case 'pt-br':
        produtos = 'Produtos'
        compensados = 'Compensados'
        break;
      case 'en-us':
        produtos = 'Products'
        compensados = 'Plywood'
        break;
      case 'es-es':
        produtos = 'Productos'
        compensados = 'Plywood'
        break;
      default:
    }
    return (
      <Container>
        <span className="product">
          { produtos }
        </span>
        <div className="submenu">
          <div className="wrapper flex">
            <div className="column">
              <Link to="/produtos/mdf">
                <strong>MDF</strong>
              </Link>
              <div className="line">
                {
                  this.state.mdf && this.state.mdf.map((item, index) => {
                    return (
                      <Link key={ index } to={ `/produtos/${item.uid}` }>
                        <span className="img">
                          <span style={ { backgroundImage: `url(${item.data.imagem.url})` } }></span>
                        </span>
                        <span className="text">
                          { item.data.nome[0].text }
                        </span>
                      </Link>
                    )
                  })
                }
              </div>
            </div>
            <div className="column">
              <Link to="/produtos/compensados">
                <strong>{ compensados }</strong>
              </Link>
              <div className="line">
                {
                  this.state.compensados && this.state.compensados.map((item, index) => {
                    return (
                      <Link key={ index } to={ `/produtos/${item.uid}` }>
                        <span className="img">
                          <span style={ { backgroundImage: `url(${item.data.imagem.url})` } }></span>
                        </span>
                        <span className="text">
                          { item.data.nome[0].text }
                        </span>
                      </Link>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

Submenu.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

Submenu.contextType = LanguageContext;

export default Submenu;
